// @flow
import type { BookingId, ExtrasId, PassengerId } from "mmb/types/primitiveTypes"
import { PASSENGER_EDIT } from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingPassengerEdit/services/consts"

export type PassengerChange = {
  booking_id: BookingId,
  created_at: number,
  id: number,
  is_automated: boolean,
  passenger_ids: Array<PassengerId>,
  stage: string,
  abid?: ExtrasId,
  updated_at: number,
}

type PassengerChangeWithCategory = {
  ...PassengerChange,
  category: string,
}

export type PassengerEditRequestsType = Array<PassengerChange>

export default function(
  passengerEditRequests: PassengerEditRequestsType = [],
): Array<PassengerChangeWithCategory> {
  return passengerEditRequests.map(change => {
    return {
      ...change,
      category: PASSENGER_EDIT,
    }
  })
}
